import { useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '../constants/index';

export const useRefetchQueries = (...keys: QueryKey[]) => {
  const queryClient = useQueryClient();

  return {
    refetchQueries: () => {
      for (const key of keys) {
        queryClient.refetchQueries({ queryKey: [key], exact: false });
      }
    },
  };
};
